<template>
  <template v-if="installation.possible">
    <button v-if="variante === 'tete'" type="button" class="btn btn-sm btn-light installer-tete" @click="lancer" title="Installer Boutique Pro sur cet appareil">
      <i class="bi bi-download"></i><span class="d-none d-xl-inline">Installer l'application</span>
    </button>
    <button v-else type="button" class="btn btn-outline-primary w-100 installer-carte" @click="lancer">
      <i class="bi bi-phone"></i> Installer l'application sur cet appareil
    </button>
  </template>

  <Fenetre v-if="aideIos" titre="Installer Boutique Pro" @fermer="aideIos = false">
    <p>Sur iPhone et iPad, l'installation se fait depuis <strong>Safari</strong> :</p>
    <ol class="etapes">
      <li>Touchez le bouton <strong>Partager</strong> <i class="bi bi-box-arrow-up"></i> en bas de l'écran (en haut sur iPad).</li>
      <li>Faites défiler et choisissez <strong>« Sur l'écran d'accueil »</strong> <i class="bi bi-plus-square"></i>.</li>
      <li>Touchez <strong>Ajouter</strong>. L'icône Boutique Pro apparaît avec vos autres applications.</li>
    </ol>
    <p class="small text-muted mb-0">Ouvrez ensuite Boutique Pro depuis cette icône : l'application s'affiche en plein écran, sans barre d'adresse.</p>
    <template #pied><button class="btn btn-primary" @click="aideIos = false">J'ai compris</button></template>
  </Fenetre>
</template>

<script>
import Fenetre from "@/components/commun/Fenetre.vue";
import { installation, installer } from "@/pwa";
import { notifier } from "@/api";

export default {
  name: "InstallerApplication",
  components: { Fenetre },
  props: {
    /** "tete" : petit bouton de la barre du haut ; "carte" : bouton large (page de connexion) */
    variante: { type: String, default: "tete" },
  },
  data: () => ({ installation, aideIos: false }),
  methods: {
    async lancer() {
      const r = await installer();
      if (r === "ios") this.aideIos = true;
      else if (r === "installee") notifier("Boutique Pro est installée : retrouvez-la avec vos applications.", "success");
      else if (r === "indisponible") notifier("Ouvrez Boutique Pro dans Chrome ou Edge pour l'installer.", "info");
    },
  },
};
</script>

<style scoped>
.installer-tete { display: inline-flex; align-items: center; gap: 6px; font-weight: 600; }
.installer-carte { display: inline-flex; align-items: center; justify-content: center; gap: 8px; font-weight: 600; }
.etapes { padding-left: 1.2rem; display: flex; flex-direction: column; gap: 8px; }
</style>
